export default __webpack_public_path__ + "static/hermosa-bataan-0834afbf1ce6cdbd8e444a0611dca802.jpg";